var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2541 9.83145C31.0847 9.20071 30.7527 8.62552 30.2912 8.16344C29.8297 7.70136 29.2549 7.36859 28.6244 7.19844C26.3035 6.57422 17 6.57422 17 6.57422C17 6.57422 7.69648 6.57422 5.37559 7.19512C4.74479 7.36472 4.16973 7.6973 3.70814 8.15947C3.24656 8.62164 2.9147 9.19712 2.7459 9.82812C2.125 12.1523 2.125 17 2.125 17C2.125 17 2.125 21.8477 2.7459 24.1686C3.08789 25.4502 4.09727 26.4596 5.37559 26.8016C7.69648 27.4258 17 27.4258 17 27.4258C17 27.4258 26.3035 27.4258 28.6244 26.8016C29.9061 26.4596 30.9121 25.4502 31.2541 24.1686C31.875 21.8477 31.875 17 31.875 17C31.875 17 31.875 12.1523 31.2541 9.83145ZM14.0449 21.4492V12.5508L21.748 16.9668L14.0449 21.4492Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.edeece0d5fefb881fe37bbfda5c157d3.svg";
export { ForwardRef as ReactComponent };